export default {
    FLYOUT_CLOSED: 'FLYOUT_CLOSED',
};
